<script setup lang="ts">
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
import UserAvatar from "@/components/ui/UserAvatar/UserAvatar.vue";
import type { FieldChange } from "@/model/change";
import type { AuthUser } from "@/model/user";

defineProps<{ field: FieldChange<AuthUser> }>();
</script>

<template>
  <div class="change horizontal">
    <template v-if="field.old">
      <span class="change-value">
        <UserAvatar :user="field.old" />
        {{ field.old.name }}
      </span>
      <SvgIcon
        name="arrow/right"
        width="20"
        height="20"
        role="img"
        :aria-label="$t('label.cardDiff.changedTo')"
      />
    </template>
    <span v-if="field.new" class="change-value">
      <UserAvatar :user="field.new" />
      {{ field.new.name }}
    </span>
  </div>
</template>
